import React from "react";
import { Grid } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
// styles
import useStyles from "./styles";

// components
import Widget from "../../Widget";
import { Typography } from "../../Wrappers";

export default function TileList(props) {
  var { product, data } = props;
  var classes = useStyles();

  return (
    <Widget header={
      <div>
        <Typography variant="h5">{product}</Typography>
      </div>
    }
    upperTitle >
      <Typography variant="h5">{product}</Typography>
      <div className={classes.totalValueContainer}>
      <Grid container spacing={4}>
            <Grid item xs={12}>
              <MUIDataTable
                title={false}
                data={data}
                columns={[
                  {
                    name    : 'name',
                    options : {
                      empty  : false,
                      filter : false,
                      sort   : false,                     
                    }
                  },{
                    name    : 'value',
                    options : {
                      empty  : false,
                      filter : false,
                      sort   : false, 
                    }
                  }
                ]}
              />
            </Grid>
          </Grid>
      </div>
    </Widget>
  );
}
